import React, { useEffect, useState } from "react";
import Recent from "./Recent";
import Allocated from "./Allocated";
import Closed from "./Closed";
import { useLocation } from "react-router-dom";
import { useAdmin } from "../../../components/Common/FilterContext/AdminPanelContext";
import Header from "../../../components/Header";

const SiteNotification = () => {
  const location = useLocation();
  const { savePageState, getPageState, clearPageState } = useAdmin();
  const pageKey = location.pathname;
  const tab = location.state?.tab;
  const saved = getPageState(pageKey);
  const [activeTab, setActiveTab] = useState(
    tab ? tab : saved?.activeTab || "Recent",
  );
  const [sites, setSites] = useState(saved?.sites || "");
  const [companies, setCompanies] = useState(null);

  // useEffect(() => {
  //   const stored = localStorage.getItem("Notifications");
  //   if (stored) {
  //     setActiveTab(JSON.parse(stored));
  //   } else {
  //     setActiveTab("Recent");
  //     localStorage.setItem("Notifications", JSON.stringify("Recent"));
  //   }
  // }, []);

  const handleTab = (type) => {
    setActiveTab(type);
    savePageState(pageKey, {
      activeTab: type,
    });
  };

  return (
    <div className="dashRightView">
      <Header name={"Alert Notification"} />
      <div className="tab-header d-flex gap-3 mb-3">
        <button
          className={`tab-btn ${activeTab === "Recent" ? "active" : ""}`}
          onClick={() => handleTab("Recent")}
        >
          New
        </button>
        <button
          className={`tab-btn ${activeTab === "Allocated" ? "active" : ""}`}
          onClick={() => handleTab("Allocated")}
        >
          Assigned
        </button>
        <button
          className={`tab-btn ${activeTab === "Closed" ? "active" : ""}`}
          onClick={() => handleTab("Closed")}
        >
          Closed
        </button>
      </div>

      <div>
        {activeTab === "Recent" && (
          <Recent
            site={"site"}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Allocated" && (
          <Allocated
            site={"site"}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
        {activeTab === "Closed" && (
          <Closed
            site={"site"}
            sites={sites}
            setSites={setSites}
            companies={companies}
            setCompanies={setCompanies}
          />
        )}
      </div>
    </div>
  );
};

export default SiteNotification;
